import React, { useContext } from 'react';
import { pick } from 'ramda';

const GatsbyContext = React.createContext({});

export const GatsbyContextProvider = ({ children, context }) => {
  return <GatsbyContext.Provider value={pick(['piLabels'], context)}>{children}</GatsbyContext.Provider>;
};

export const useGatsbyContext = () => {
  return useContext(GatsbyContext);
};
